import React from 'react';

const OPTIONS = [
    { value: 'ALL', label: 'Tất cả' },
    { value: 'SYSTEM', label: 'SYSTEM' },
    { value: 'NORMAL', label: 'NORMAL' },
];

/**
 * Filter "Loại" gắn NGAY tiêu đề cột Loại của bảng.
 *
 * - CẢ CỤM "Loại ▾" là một <button>: bấm vào chữ hoặc mũi tên đều mở menu
 *   (vùng bấm ~60x24px nên thao tác nhanh không bị trượt).
 * - Không nền / không khung: nhìn như tiêu đề bình thường, hover chỉ đổi màu xanh.
 * - Mũi tên là tam giác vẽ bằng CSS (.loai-th-caret), không dùng glyph ▾ nên
 *   không bị nhỏ / lệch tuỳ font của từng máy.
 * - Khi đang lọc, tiêu đề cột đổi thành chính giá trị đang lọc
 *   (vd chọn SYSTEM -> tiêu đề "Loại" thành "SYSTEM") cho trực quan.
 * - Menu: Tất cả / SYSTEM / NORMAL. Muốn bỏ lọc -> chọn "Tất cả".
 */
export default function LoaiHeaderFilter({ value, onChange, label = 'Loại' }) {
    const active = !!value && value !== 'ALL';

    return (
        <th className={'align-middle loai-th' + (active ? ' is-active' : '')} scope="col">
            {/*
             * Cả cụm "Loại ▾" là MỘT nút: bấm vào chữ hay mũi tên đều mở menu
             * -> vùng bấm ~60x24px (thay vì ~10x12px của ký tự ▾ trần như trước).
             */}
            <button
                type="button"
                className="loai-th-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                title="Lọc theo loại"
            >
                <span className="loai-th-label">{active ? value : label}</span>
                <span className="loai-th-caret" aria-hidden="true" />
            </button>
            <div className="dropdown-menu" data-boundary="window">
                {OPTIONS.map((o) => (
                    <a
                        key={o.value}
                        href="#!"
                        className={'dropdown-item' + (value === o.value ? ' active' : '')}
                        onClick={(e) => {
                            e.preventDefault();
                            onChange(o.value);
                        }}
                    >{o.label}</a>
                ))}
            </div>
        </th>
    );
}
